import { transactionDateStore } from "hooks";

export const mdmFilterState = (venue) => {
  const { venueId, startDate, endDate } = transactionDateStore(venue);
  return {
    venueId,
    searchKey: "",
    pageable: true,
    page: 1,
    pageSize: 20,
    dateRange: [startDate, endDate],
    softwareVersion: "",
  };
};
